module.exports = __webpack_public_path__ + "img/1234704778.24e5c3b7.jpg";